import React, { Component } from 'react';
import { Section, Header } from '../components/ui';

// Desing
import logo from '../assets/img/logo.svg';
import concept from '../assets/img/parking-concept-new.png';
import cards from '../assets/img/kortalogo.png';

class Policy extends Component {
    render() {
        const slogan = 'Góð geymsla fyrir bílinn meðan þú ferðast. Njóttu einfaldar og fljótlegrar þjónustu Lagningar';
        return (
            <div>
                <Header title={'Tryggðu þér stæði'} subtitle={slogan} concept={concept} logo={logo} />
                <Section title={'Skilmálar'}>
                    <h3>Greiðsluskilmálar</h3>
                    <p>Um leið og greiðsla hefur verið innt af hendi fær kaupandi staðfestingu og kvittun á netfang sitt.</p>
                    <p>Almenn verðskrá Lagningar er eftirfarandi:</p>

                    <p>
                        Gjöld vegna <b>bílastæðaþjónustu:</b>
                    </p>
                    <ul>
                        <li>Geymslugjald 590 kr. á sólarhring (án vsk.)</li>
                        <li>Grunngjald bílastæðis 5.900 kr. (blandaður vsk.)</li>
                        <li>Innigeymsla aukalega 990 kr. á dag (án vsk.)</li>
                    </ul>

                    <p>
                        Gjöld vegna <b>viðbótarþjónustu:</b>
                    </p>
                    <ul>
                        Alþrif & bón
                        <li>Fólksbíll 18.000 kr. m.vsk</li>
                        <li>Jepplingur 19.500 kr. m.vsk</li>
                        <li>Jeppi 19.900 kr. m.vsk</li>
                        <li>Bíll í yfirstærð 26.000 kr. m.vsk</li>
                    </ul>
                    <ul>
                        <li>Hraðþrif 7.900 kr. m.vsk</li>
                    </ul>

                    {/* <ul>
                        Þrif að utan & bón
                        <li>Fólksbíll 10.900 kr. m.vsk</li>
                        <li>Jepplingur 12.900 kr. m.vsk</li>
                        <li>Jeppi 13.900 kr. m.vsk</li>
                        <li>Bíll í yfirstærð 18.900 kr. m.vsk</li>
                    </ul> */}

                    <b>Önnur þjónusta</b>
                    <ul>
                        <li>þjónustugjald fyrir að fylla eldsneyti 1.900 kr. með vsk.</li>
                        <li>þjónustugjald fyrir að fylla á rúðuvökva 1.900 kr. með vsk.</li>
                    </ul>

                    <br />
                    <br />

                    <p>Kaupandi ber ábyrgð á því að réttar upplýsingar komi fram við kaup.</p>
                    <p>Endursala stæðaleigu sem og þjónustu Lagningar með hagnaði fyrir kaupanda eða þriðja aðila er óheimil.</p>
                    <p>Allar greiðslur fara í gegnum viðurkennda greiðslugátt hjá Saltpay.</p>
                    <p>
                        Endurgreiðsla fæst samþykkt ef beiðni berst til Lagningar meira en 12 tímum fyrir settan komutíma
                        bifreiðar.
                    </p>
                    <br />
                    <br />
                    <img src={cards} alt="" style={{ width: '100%' }} />
                    <br />
                    <br />
                    <br />
                    <br />

                    <b>Persónuupplýsingar</b>
                    <p>
                        Seljandi heitir kaupanda fullum trúnaði um allar þær upplýsingar sem kaupandi gefur upp í tengslum við
                        viðskiptin. Upplýsingar frá kaupanda verða ekki afhentar þriðja aðila undir neinum kringumstæðum.
                    </p>

                    <b>Ábyrgðarmál</b>
                    <p>
                        Bílastæði Lagningar er afgirt og þar er starfsemi allan sólarhringinn og eru bílastæði vöktuð með hágæða
                        myndavélabúnaði. Hvorki farangurskerrur né fríhafnargrindur ganga lausar á bílastæðum Lagningar og því er
                        engin hætta á tjóni af þeirra völdum.
                    </p>

                    <p>
                        Ef hið ólíklega gerist að tjón hafi sannanlega átt sér stað á meðan bifreið var í umsjá Lagningar, greiðir
                        Lagning sjálfsábyrgð samkvæmt ákvæðum tryggingarskilmála eiganda bílsins. Þetta á ekki við um bilanir eða
                        tjón sem rekja má til náttúrulegrar veðrunnar eða eðlilegrar notkunar bifreiðarinnar að þeim tímapunkti.
                    </p>

                    <h3>Ágreiningur</h3>
                    <p>
                        Rísi ágreiningur milli aðila um efni þessara skilmála eða vegna brota á þeim má bera viðkomandi mál undir
                        Kærunefnd þjónustu og lausafjárkaupa hjá Neytendastofu. Ef allt þrýtur er heimilt að reka mál vegna þessa
                        fyrir Héraðsdómi Reykjavíkur skv. ákvæðum laga nr. 91/1991.
                    </p>

                    <h3>Almennar fyrirtækjaupplýsingar.</h3>
                    <p>Lagning ehf.</p>
                    <p>Suðurlandsbraut 30, 108 Reykjavík</p>
                    <p>lagning@lagning.is</p>
                    <p>Kennitala: 5201212500</p>
                    <br />
                    <p>Virðisaukaskattsnúmer: 142638</p>
                </Section>
            </div>
        );
    }
}

export default Policy;



// WEBPACK FOOTER //
// ./src/views/Policy.js